import usePartnerAuthStore from '@/stores/partnerAuthStore';
import type { NavigationGuardWithThis } from 'vue-router';

export default <NavigationGuardWithThis<undefined>>(async (
  _to,
  _from,
  next,
) => {
  const partnerAuthStore = usePartnerAuthStore();

  if (!partnerAuthStore.meChecked) {
    await partnerAuthStore.getMe();
  }

  if (partnerAuthStore.isAuth) {
    return next({ name: 'partner.dashboard' });
  }

  return next();
});
